import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

export function Text(props) {
  const className = `timer_time_text ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

Text.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

Text.defaultProps = {
  className: '',
};
